import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Blogs.css';

const Blogs = () => {
  const navigate = useNavigate();
  const [blogPosts, setBlogPosts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);

  const fetchBlogPosts = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.github.com/repos/Aditys018/PortfolioBlogs/contents/content/blogs');
      const data = await response.json();

      if (Array.isArray(data)) {
        const blogFetches = data
          .filter((item) => item.name.endsWith('.md'))
          .map(async (item) => {
            const res = await fetch(item.download_url);
            const text = await res.text();

            const frontmatterRegex = /^---\s*([\s\S]*?)\s*---/;
            const match = text.match(frontmatterRegex);

            const metadata = {};
            if (match) {
              const lines = match[1].split('\n');
              let currentKey = null;
              let isMultiline = false;

              for (let i = 0; i < lines.length; i++) {
                const line = lines[i];

                if (/^\s*$/.test(line)) continue;

                const keyValueMatch = line.match(/^([a-zA-Z0-9_-]+):\s*(.*)$/);
                if (keyValueMatch) {
                  const [, key, value] = keyValueMatch;
                  currentKey = key.trim();

                  if (value === '>' || value === '|') {
                    isMultiline = true;
                    metadata[currentKey] = '';
                  } else {
                    metadata[currentKey] = value.trim().replace(/^["']|["']$/g, '');
                    isMultiline = false;
                  }
                } else if (isMultiline && currentKey && line.startsWith(' ')) {
                  metadata[currentKey] += line.trim() + ' ';
                } else {
                  isMultiline = false;
                }
              }

              Object.keys(metadata).forEach((key) => {
                metadata[key] = metadata[key].trim();
              });
            }

            return {
              title: metadata.title || item.name.replace('.md', ''),
              author: metadata.author || 'Unknown',
              date: metadata.date || '',
              excerpt: metadata.excerpt || '',
              image: metadata.image || '',
              slug: item.name.replace('.md', ''),
            };
          });

        const blogs = await Promise.all(blogFetches);
        blogs.sort((a, b) => {
          const dateA = new Date(a.date);
          const dateB = new Date(b.date);
          return dateB - dateA;
        });

        setBlogPosts(blogs);
      } else {
        console.error('Expected array from GitHub response');
      }
    } catch (err) {
      console.error('Error fetching blog posts:', err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchBlogPosts();
    const interval = setInterval(fetchBlogPosts, 60000);
    return () => clearInterval(interval);
  }, []);

  const filteredPosts = blogPosts.filter((post) =>
    post.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="blogs-container">
      <div className="blogs-header">
        <h1>BLOG POSTS</h1>
        <h2 className="test-heading">(Testing in Prod)</h2>
        <input
          type="text"
          placeholder="Search blog..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="blog-search-input"
        />
      </div>

      <div className="blogs-grid">
        {loading ? (
          <p>Loading blogs...</p>
        ) : filteredPosts.length > 0 ? (
          filteredPosts.map((post) => (
            <div key={post.slug} className="blog-card">
              {post.image && (
                <div className="blog-image">
                  <img src={post.image} alt={post.title} />
                </div>
              )}
              <div className="blog-details">
                <h2>{post.title}</h2>
                <p className="blog-meta">
                  By {post.author} ·{' '}
                  {post.date ? new Date(post.date).toLocaleDateString() : ''}
                </p>
                <p className="blog-excerpt">{post.excerpt}</p>
                <button
                  className="continue-reading-btn"
                  onClick={() => navigate(`/blogs/${post.slug}`)}
                >
                  Continue Reading →
                </button>
              </div>
            </div>
          ))
        ) : (
          <p>No blog posts found.</p>
        )}
      </div>
    </div>
  );
};

export default Blogs;
